// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__1hRg9","letter":"styles_letter__21TYr"};